export const GET_CAPSULE = "GET_CAPSULE";
export const GET_SELECTED_CAPSULE = "GET_SELECTED_CAPSULE"